import {useEffect} from 'react'
import {useUserPreferences} from '@data/queries/preferences/userPreferences.main'
import {useWebsiteMenuInformation} from '@data/queries/website/websiteMenuInformation.main'
import {EVENTS} from '@helpers/analytics/events'
import {BrowseTaxonomies} from '@helpers/analytics/events/browse'
import {sendEvent} from '@helpers/analytics/sendEvents'
import useEventsBaseProperties from '@hooks/useEventsBaseProperties'

export default function TrackPageView() {
  const userPreferences = useUserPreferences()
  const eventBaseProperties = useEventsBaseProperties()
  const {website, design} = useWebsiteMenuInformation()

  useEffect(() => {
    if (!userPreferences?._id) return

    sendEvent<BrowseTaxonomies['orderPageViewed']>(EVENTS.browse.orderPageViewed, {
      menulayoutDesign: website.menuLayout,
      productCardDesign: design?.design.productCardDesign,
      menuId: userPreferences.menuId ?? '',
      ...eventBaseProperties
    })
  }, [userPreferences?._id])

  return null
}
